module.exports = __webpack_public_path__ + "static/media/small-close.4d94b803.svg";